export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "APP ID",
    accessor: "app_id",
  },
  {
    Header: "APP NAME",
    accessor: "app_name",
  },
  {
    Header: "APP URL",
    accessor: "app_url",
  },
  {
    Header: "PAYMENT METHOD",
    accessor: "payment_method",
  },
  {
    Header: "CREATED DATE",
    accessor: "createdAt",
  },
  {
    Header: "UPDATED DATE",
    accessor: "updatedAt",
  },
  {
    Header: "STATUS",
    accessor: "isDeleted",
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];
export const columnsDataCheckGateWay = [
  {
    Header: "GATEWAY NAME",
    accessor: "gateway_name",
  },
  {
    Header: "SECRET KEY",
    accessor: "secret_key",
  },
  {
    Header: "PUBLISHING KEY",
    accessor: "publishing_key",
  },
  {
    Header: "MODE",
    accessor: "mode",
  },
   {
    Header: "STATUS",
    accessor: "is_active",
  },
  {
    Header: "CREATED DATE",
    accessor: "createdAt",
  },
  {
    Header: "UPDATED DATE",
    accessor: "updatedAt",
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];
export const columnsDataColumns = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "isDeleted",
  },
  {
    Header: "ROLE",
    accessor: "role",
  },
  {
    Header: "CREATED DATE",
    accessor: "createdAt",
  },
  {
    Header: "UPDATED DATE",
    accessor: "updatedAt",
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];
export const columnsDataColumnsUser = [
    {
    Header: "IMG",
    accessor: "img_Url",
  },
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "isDeleted",
  },
  {
    Header: "ROLE",
    accessor: "role",
  },
  {
    Header: "CREATED DATE",
    accessor: "createdAt",
  },
  {
    Header: "UPDATED DATE",
    accessor: "updatedAt",
  },
  {
    Header: "ACTION",
    accessor: "action",
  },
];
export const columnsTransectionDataColumns = [
  {
    Header: "Order ID",
    accessor: "order_id",
  },
  {
    Header: "User Name",
    accessor: "userName", // from userId.name
  },
  {
    Header: "User Email",
    accessor: "userEmail", // from userId.email
  },
  {
    Header: "App ID",
    accessor: "appId", // from appId.app_id
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Mode",
    accessor: "mode",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Created At",
    accessor: "createdAt",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];
